export default __webpack_public_path__ + "static/media/bg1.496f347d.jpg";